import { AnyAction } from "redux";

export type SagaFunction<A = AnyAction> = (action: A) => IterableIterator<any>;

export enum Action {
  LOAD_ADMINISTRABLE_ORG_IDS = "ORGANIZATIONS/LOAD_ADMINISTRABLE_ORG_IDS",
  HANDLE_LOAD_ADMINISTRABLE_ORG_IDS_SUCCESS = "ORGANIZATIONS/HANDLE_LOAD_ADMINISTRABLE_ORG_IDS_SUCCESS",
  HANDLE_LOAD_ADMINISTRABLE_ORG_IDS_FAILURE = "ORGANIZATIONS/HANDLE_LOAD_ADMINISTRABLE_ORG_IDS_FAILURE",
}
